export default __webpack_public_path__ + "static/media/Seek-1-1.21e5a6cf.png";